module.exports = __webpack_public_path__ + "img/icon_fb_outline.c24464a9.svg";